import { Component, output, input } from "@angular/core";
import { SupportModel } from "./model/support-model";
import { MessageModel } from "./model/message-model";
import { NgStyle } from "@angular/common";

@Component({
  selector: "portal-support",
  templateUrl: "./support.component.html",
  styleUrls: ["./support.component.scss"],
  standalone: true,
  imports: [NgStyle],
})
export class SupportComponent {
  readonly supportModel = input.required<SupportModel>();
  readonly sendPressed = output<MessageModel>();

  onSendPressed(firstname: string, lastname: string, email: string, message: string, subject: string) {
    this.sendPressed.emit({
      firstname: firstname,
      lastname: lastname,
      email: email,
      message: message,
      subject: subject,
    });
  }
}
